export default {
	UNAUTHORIZED: 403,
};
